// extracted by mini-css-extract-plugin
export default {"container":"_1fb7YqCtbM5-Ge-rEIcxUj","heading":"_2F4zJWHra48y0siXOJfIXs","content":"_2Cdg-ncyYbNMrWFH0PC8eR","item":"_1WoVpMO4ZFAgE4KfNWxKfL"};